export default "__VITE_ASSET__CWQTIf_g__"